<template>
  <div class="banner">
    <section class="section">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="title">Banner</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <router-link class="button is-info" :to="{name: 'banner.create'}">
              Create
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <b-table :data="banners ? banners.docs : []">
        <template slot-scope="props">
          <b-table-column label="Media">
            <div class="image" v-if="props.row.type === 'image'">
              <img :src="getAssetPreview(props.row)">
            </div>
          </b-table-column>
          <b-table-column field="title" label="Title">
            {{ props.row.title }}
          </b-table-column>
          <b-table-column field="button" label="Button">
            {{ props.row.button }}
          </b-table-column>
          <b-table-column field="url" label="URL">
            {{ props.row.url }}
          </b-table-column>
          <b-table-column field="activeAt" label="Active At" centered>
            {{ $moment(props.row.activeAt).format('d MMM Y') }}
          </b-table-column>
          <b-table-column field="expiredAt" label="Expired At" centered>
            {{ props.row.expiredAt ? $moment(props.row.expiredAt).format('d MMM Y') : '-' }}
          </b-table-column>
          <b-table-column field="createdAt" label="Created At" centered>
            {{ $moment(props.row.createdAt).format('d MMM Y HH:mm:ss') }}
          </b-table-column>
          <b-table-column label="Action" centered>
            <div class="buttons">
              <router-link
                class="button is-warning"
                :to="{name: 'banner.info', params: {id: props.row.id}}"
              >
                <b-icon icon="edit" size="is-small" />
              </router-link>
              <button class="button is-danger" @click="onDelete(props.row.id)">
                <b-icon icon="trash-alt" size="is-small" />
              </button>
            </div>
          </b-table-column>
        </template>
      </b-table>
      <b-loading :is-full-page="false" :active.sync="isLoading" />
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'banner',
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters('banner', ['banners']),
  },
  methods: {
    ...mapActions('banner', ['getBanners', 'delete']),
    getAssetPreview(banner) {
      const asset = banner.BannerAssets.find(i => i.type === banner.type && i.url !== null);
      return asset ? asset.url : null;
    },
    fetch() {
      this.isLoading = true;

      this.getBanners({
        page: this.$route.query.page || 1,
      }).finally(() => {
        this.isLoading = false;
      });
    },
    onDelete(id) {
      this.$swal.fire({
        title: 'Delete ?',
        type: 'warning',
        showCancelButton: true,
        /* eslint-disable arrow-body-style */
        preConfirm: () => {
          return this.delete(id);
        },
        /* eslint-enable arrow-body-style */
      }).then(() => {
        this.fetch();
        this.$swal.fire('Deleted!');
      });
    },
  },
  mounted() {
    if (!this.banners) {
      this.fetch();
    }
  },
};
</script>
